import { z } from 'zod';
import { revenueBrandSchema } from '../revenueBrand.js';
import { subscriptionBillingCadenceSchema } from './subscriptionBillingCadence.js';
import { subscriptionPaymentMethodSchema } from './subscriptionPaymentMethod.js';
import { subscriptionSaleTypeSchema } from './subscriptionSaleType.js';
import { subscriptionStatusSchema } from './subscriptionStatus.js';
export const subscriptionOutputSchema = z.object({
    // The ops tool addresses subscriptions by id; the uuid is what anything partner-facing uses.
    id: z.number().int().positive(),
    uuid: z.uuid(),
    status: subscriptionStatusSchema,
    planId: z.number().int().positive(),
    paymentMethod: subscriptionPaymentMethodSchema,
    billingCadence: subscriptionBillingCadenceSchema,
    saleType: subscriptionSaleTypeSchema,
    revenueBrand: revenueBrandSchema,
    // Net of MWST, like every amount in this domain, and serialised as a string so no precision is lost in transit.
    pricePerMonth: z.string(),
    upfrontPrice: z.string().nullable(),
    commitmentLengthInMonths: z.number().int().positive(),
    agreedStartAt: z.iso.datetime().nullable(),
    initialFreeDays: z.number().int().min(0),
    creditsCoverageDays: z.number().int().min(0),
    partnerContactId: z.number().int().positive().nullable(),
    ticketId: z.number().int().positive().nullable(),
    linkedPcmContractId: z.number().int().positive().nullable(),
    linkedPartnerProductId: z.number().int().positive().nullable(),
    linkedSubscriptionId: z.number().int().positive().nullable(),
    salesAssigneeId: z.number().int().positive().nullable(),
    telesalesAssigneeId: z.number().int().positive().nullable(),
    comment: z.string().nullable(),
});
